import { defineStore } from "pinia";

export const useCatalogAwardsStore = defineStore("CatalogAwardsStore", {
  state: () => ({
    data: null,
    loading: false,
  }),
  actions: {
    async fetchAwards(query) {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/api/v1/catalog/awards?q[name_cont]=${query}`);
        this.data = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    },
    async fetchAward(id) {
      try {
        const response = await this.$axios.get(`api/v1/catalog/awards/${id}`);
        return response;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  }
});
